<template>
  <div class="ima-slogan-list">

    <ima-loading-spinner v-if="slogans.isLoading"></ima-loading-spinner>

    <div v-else>
      <h1 class="title">Slogans</h1>

      <ima-filter-toolbar :activeFilters="activeFilters">

        <b-field>
          <b-input placeholder="Suchen" type="search" icon="search" v-model="filter.term.value"></b-input>
        </b-field>
      </ima-filter-toolbar>

      <b-table class="ima-slogan-list__table" :data="filteredData" :checked-rows.sync="selected" :striped="true" :checkable="true" :loading="slogans.isLoading" :mobile-cards="true" :paginated="true" :per-page="25" :pagination-simple="true" default-sort="['id']">

        <template slot-scope="props">

          <b-table-column field="id" label="ID" sortable numeric>
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="text" label="Text" sortable>
            {{ props.row.text }}
          </b-table-column>

          <b-table-column field="description" label="Beschreibung" sortable>
            {{ props.row.description }}
          </b-table-column>

          <b-table-column field="createdAt" label="Erstellt" class="nowrap">
            {{props.row.createdAt | moment('DD.MM.YYYY HH:mm')}}
          </b-table-column>

          <b-table-column field="updatedAt" label="Zuletzt bearbeitet" class="nowrap">
            {{props.row.createdAt | moment('DD.MM.YYYY HH:mm')}}
          </b-table-column>

          <b-table-column field="actions" label=" ">
            <div class="control">

            <button v-if="canEditSlogans" class="button round-button is-primary" type="button" @click="onSloganEdit(props.row)">
              <span class="icon">
                <b-icon icon="mode_edit"></b-icon>
              </span>
            </button>

            <!--button v-if="canDeleteSlogans" class="button round-button is-danger" type="button" @click="onSloganRemove(props.row)">
              <span class="icon">
                <b-icon icon="delete" />
              </span>
            </button-->

          </div>
                  </b-table-column>

        </template>

        <div slot="empty">
          Keine Slogans verfügbar
        </div>
      </b-table>

      <button v-if="this.canCreateSlogans" class="button floating-button" @click="openSloganModal()">
                <b-icon icon="add"></b-icon>
              </button>
    </div>

  </div>
</template>

<script>
// import { uniq, sortBy } from 'lodash'
import routes from '@/mixins/routes'
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  fetchSlogans,
  selectSlogan,
  deleteSlogan
} from '@/store/modules/slogans'
import { openSloganModal } from '@/store/modules/modals'
import filterListing from '@/mixins/filter-listing'
import FilterToolbar from '@/components/FilterToolbar'
import LoadingSpinner from '@/components/LoadingSpinner'
import {
  canCreateSlogans,
  canDeleteSlogans,
  canEditSlogans
} from '@/services/permissions'

export default {
  name: 'ima-slogan-list',
  components: {
    'ima-loading-spinner': LoadingSpinner,
    'ima-filter-toolbar': FilterToolbar
  },
  mixins: [routes, filterListing],
  data () {
    return {
      filter: {
        term: {
          value: null,
          filter (slogan) {
            return [slogan.id, slogan.text, slogan.description]
              .join()
              .toLowerCase()
              .includes(this.value.toLowerCase())
          }
        }
      },
      selected: []
    }
  },
  methods: {
    ...mapMutations([openSloganModal, selectSlogan]),
    ...mapActions([fetchSlogans, deleteSlogan]),
    onSloganEdit (slogan) {
      this.selectSlogan(slogan)
      this.openSloganModal()
    },
    onSloganRemove (slogan) {
      this.$dialog.confirm({
        title: 'Slogan löschen',
        message: `Sind Sie sicher dass Sie den Slogan "<strong>${slogan.text}</strong>" unwiderruflich <strong>löschen</strong> wollen?`,
        confirmText: 'Slogan löschen',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteSlogan(slogan)
        }
      })
    }
  },
  computed: {
    ...mapState(['slogans']),
    filteredData () {
      return this.filterCollection(this.slogans.data)
    },
    canCreateSlogans () {
      return canCreateSlogans()
    },
    canDeleteSlogans () {
      return canDeleteSlogans()
    },
    canEditSlogans () {
      return canEditSlogans()
    }
  },
  created () {
    this.fetchSlogans()
  }
}
</script>

<style lang="scss">
.ima-slogan-list {
}
</style>




// WEBPACK FOOTER //
// src/components/SloganList.vue